<template>
<div>
    <div class="form-container ou-donation-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">
                <FormSection title="">
                    <br/>
                    <div style="position:relative">
                        <AmountSelectorSiyum26 :nocustom="true"/>
                        <ErrorLabel field="amount" style="position:relative"/>
                    </div>
                    <div class="note" v-if="form.amount >= 500">
                      Thank you for dedicating a perek/perakim. You will receive a separate email with a perek choice and dedication form. Forms will be sent out after February 2, 2026.
                    </div>

                    <TransactionFeeOuwomen />
                    <br/>

                    <div v-if="form.amount && form.amount >= 100">
                        <FormRow inline>
                            <FormCol field="custom.listingName" width="half" :showLabel="false">
                                <label class="control-label">Listing name for global virtual journal</label>
                                <FormInput type="text" />
                            </FormCol>
                        </FormRow>
                        <FormRow inline v-if="form.amount && form.amount > 100">
                          <div>
                            <label class="control-label">Dedication message for global virtual journal</label>
                            <FormCol field="dedicationMessage" :showLabel="false"/>
                          </div>
                        </FormRow>
                    </div>
                </FormSection>
                <FormSection v-if="form.amount">
                  <h2>Event Attendees and Guests</h2>

                  <FormRow v-if="form.amount">
                    <div class="reserved__bstns" style="width: 800px;">
                      <div class="radio-part">
                        <input
                          id="type_attending"
                          name="Attending"
                          type="radio"
                          @click="setValue('custom.newAutoAttend', 'yes')"
                          :checked="getValue('custom.newAutoAttend') == 'yes'"
                        />
                        <FormLabel for="type_attending"> YES, WILL ATTEND </FormLabel>
                      </div>
                      <div class="radio-part">
                        <input
                          name="Attending"
                          id="type_noattending"
                          type="radio"
                          :checked="getValue('custom.newAutoAttend') == 'no'"
                          @click="setValue('custom.newAutoAttend', 'no')"
                        />
                        <FormLabel for="type_noattending"> NO, WILL NOT ATTEND </FormLabel>
                      </div>
                    </div>
                  </FormRow>
                  <div class="error" v-if="!getValue('custom.newAutoAttend')" style="font-size:12px;color:red;margin-bottom:20px;">Please select an option regarding your attendence</div>

                  <FormRow v-if="form.amount >= 1000 && getValue('custom.newAutoAttend') == 'yes'">
                      <label>How many will attend the Event?</label>
                      <select
                        style="margin-left: 20px;width:50px"
                        v-model="attending"
                        v-if="form.amount >= 1000 && getValue('custom.newAutoAttend') == 'yes'"
                        @change="setValue('custom.attending', $event.target.value.toString())"
                      >
                          <option :value="0">0</option>
                          <option :value="1" v-if="getValue('custom.newAutoAttend') != 'no'">1</option>
                          <option :value="2" v-if="form.amount >= 1000 && getValue('custom.newAutoAttend') != 'no'">2</option>
                          <option :value="3" v-if="form.amount >= 2500 && getValue('custom.newAutoAttend') != 'no'">3</option>
                          <option :value="4" v-if="form.amount >= 2500 && getValue('custom.newAutoAttend') != 'no'">4</option>
                          <option :value="5" v-if="form.amount >= 5000 && getValue('custom.newAutoAttend') != 'no'">5</option>
                          <option :value="6" v-if="form.amount >= 5000 && getValue('custom.newAutoAttend') != 'no'">6</option>
                          <option :value="7" v-if="form.amount > 5000 && getValue('custom.newAutoAttend') != 'no'">7</option>
                          <option :value="8" v-if="form.amount > 5000 && getValue('custom.newAutoAttend') != 'no'">8</option>
                          <option :value="9" v-if="form.amount > 5000 && getValue('custom.newAutoAttend') != 'no'">9</option>
                          <option :value="10" v-if="form.amount == 10000 && getValue('custom.newAutoAttend') != 'no'">10</option>
                      </select>
                  </FormRow>
                  <div v-if="getValue('custom.attending') && attending >0 && form.amount >= 1000 && getValue('custom.newAutoAttend') == 'yes'">
                      <label>Attendees Names</label>
                      <div v-for="guest in attending" :key="`guest${guest}`">
                        <FormRow inline>
                          <FormCol :field="`custom.guestsName${guest}`" width="full" :showLabel="false">
                            <FormInput type="text" class="width-full" :field="`custom.guestsName${guest}`" placeholder="Full Name"/>
                          </FormCol>
                          <FormCol :field="`custom.guestsEmail${guest}`"  width="full" :showLabel="false">
                            <FormInput type="text" class="width-full" :field="`custom.guestsEmail${guest}`"  placeholder="Email" />
                          </FormCol>
                        </FormRow>
                      </div>
                  </div>
                </FormSection>
                <FormSection title="Your Details">
                    <FormRow inline>
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>
                    <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow>
                </FormSection>
                <FormSection title="Billing Information" >
                    <DonorAddress />
                </FormSection>
                <FormSection title="Payment Information" last>
                    <FormRow inline>
                      <FormCol field="card" :showLabel="false" />
                    </FormRow>
                    <FormRow>
                    <p class="note" style="width: 100%">To pay by Check, please click <a href="https://ouwomen.org/donation-by-check-or-daf-siyum-26/" style="text-align:center">Here</a> </p>
                  </FormRow>
                    <FormRow>
                      <p class="note">We offer several payment options. Please be aware that your reservation is confirmed only after payment is completed and you receive a confirmation email. If you do not receive a confirmation email, your reservation was not completed.</p>
                    </FormRow>
                </FormSection>
                <FormSection title="Media Release Form">
                    <MediaRelease />
                </FormSection>
                <PaymentButton showAmount btnText="Payment"/>
            </PaymentForm>
        </div>
    </div>
</div>
</template>
<script lang="ts">
import { defineComponent, type PropType, ref, watch, computed, onMounted } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'


export default defineComponent({
  setup() {
    const { form, setValue, getValue } = usePaymentForm()
    const attending = ref(0)
    const attendanceThreshold = 1000

    onMounted(() => {
      setValue('signup', true)
    })

    watch(
      () => getValue('custom.newAutoAttend'),
      (value) => {
        if (value === 'no') {
          attending.value = 0
          setValue('custom.attending', '0')
        } else if (value === 'yes' && Number(form.value.amount) < attendanceThreshold) {
          attending.value = 1
          setValue('custom.attending', '1')
        }
      }
    )

    watch(
      () => form.value.amount,
      (newAmount) => {
        if (getValue('custom.newAutoAttend') === 'yes' && Number(newAmount) < attendanceThreshold) {
          attending.value = 1
          setValue('custom.attending', '1')
        }
      }
    )

    interface Name {
      firstName: string;
      lastName: string;
      email: string;
    }

    let names: Name[] = [];

    return {
      form,
      setValue,
      getValue,
      names,
      attending
    }
  },
})
</script>
<style scoped lang="scss">
::v-deep .form-container.ou-donation-form {
  position: relative;
}
.form-container.ou-donation-form {
  margin: 0px auto;
  padding: 10px;
  box-shadow: none;
  max-width: 750px;
}
::v-deep h2 {
  font-weight: 600;
  margin-bottom: 20px;
  margin-top: 40px;
  font-size: 20px;
  text-transform: uppercase;
  text-align: center;
  color: black;
}
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
::v-deep .note {
  font-style: italic;
  padding-top: 8px;
  line-height: 1.4;
  font-weight: 500;
  font-size: 14px;
  text-align: center;
  a {
    text-decoration: none;
  }
}
::v-deep .amount-row {
  min-width: 50% !important;
  max-width: 50% !important;
  margin-bottom: 0px;
  border: 2px solid rgba(243, 235, 207, 1);
  padding: 3px;

  @media (min-width: 720px) {
    min-width: 25% !important;
    max-width: 25% !important;
  }
  input[type="radio"],
  input[type="checkbox"] {
    height: 0;
    top: 20px;
    position: absolute;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
}
::v-deep .styled-radio-container--ou-donation.styled-radio-container {
  justify-content: center;

  label {
    font-weight: 500;
    padding: 22px 0px;
    border: none;
    background: white !important;
    color: #131232 !important;
    display: flex !important;
    line-height: normal;
    margin-bottom: 0px;
    &:hover {
      background: radial-gradient(
        ellipse at center,
        rgba(249, 246, 233, 1) 0%,
        rgba(255, 255, 255, 1) 5%,
        rgba(241, 232, 199, 1) 100%
      ) !important;
    }
  }
  input[type="radio"]:checked + label,
  input[type="checkbox"]:checked + label {
    background: radial-gradient(
      ellipse at center,
      rgba(249, 246, 233, 1) 0%,
      rgba(255, 255, 255, 1) 5%,
      rgba(241, 232, 199, 1) 100%
    ) !important;
  }

  textarea {
    padding: 5px 10px;
    font-family: inherit;
  }
  ::v-deep .label-description {
    background: none !important;
    display: block !important;
    text-align: center !important;
    font-size: 15px;
    font-style: italic;
    padding-top: 0;
  }
  .label-amount {
    background: none !important;
    display: inline-block !important;
    height: auto !important;
    max-width: 100%;
    text-align: center;
    color: rgba(175, 155, 83, 1);
    font-weight: 600;
    font-size: 18px;
    padding-bottom: 10px;
    margin-bottom: 7px;
    -o-border-image: url("https://res.cloudinary.com/orthodox-union/image/upload/f_auto,q_auto/v1503564922/NCSY/Rectangle-border.png")
      27 fill repeat;
    border-image: url("https://res.cloudinary.com/orthodox-union/image/upload/f_auto,q_auto/v1503564922/NCSY/Rectangle-border.png")
      27 fill repeat;
    border-style: solid;
    border-width: 0px 0px 1px 0px;
  }
  #amount_other {
    max-width: 100%;
  }
  .amount_other__wrapper::before {
    background: #0c3450 !important;
    color: white !important;
    font-weight: bold;
  }
  .amount_other__wrapper {
    margin-bottom: 18px;
  }
}

.radio-part {
  display: flex;
  gap: 10px;
  align-items: center;
  padding-bottom: 5px;
}
::v-deep label {
  line-height: normal !important;
}
.radio-part label {
  margin: 0px;
  padding: 0px;
  line-height: normal;
}

::v-deep .reserved__bstns {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  .radio-part {
    min-width: 50% !important;
    max-width: 50% !important;
    border: 2px solid #f3ebcf;
    padding: 3px;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    width: 100%;
    position: relative;

    label {
      margin: 0px;
      padding: 13px;
      cursor: pointer;
      line-height: normal;
      width: 100%;
      text-align: center;
      /* font-weight: 600; */
      font-size: 17px;
      display: block;
      color: #131232;
      text-transform: capitalize;
      letter-spacing: 2px;
    }
    input[type="radio"],
  input[type="checkbox"] {
      height: 0;
      top: 20px;
      position: absolute;
      left: 20px;
      z-index: -1;
      visibility: hidden;
    }
    label:hover {
      background: radial-gradient(
        ellipse at center,
        #f9f6e9 0%,
        white 5%,
        #f1e8c7 100%
      ) !important;
    }
    input[type="radio"]:checked + label,
    input[type="checkbox"]:checked + label {
      background: radial-gradient(
        ellipse at center,
        #f9f6e9 0%,
        white 5%,
        #f1e8c7 100%
      ) !important;
    }
  }
}

::v-deep .payment-info {
  // display: flex;
  // flex-flow: column;
  // align-items: center;
  // justify-content: center;
}
::v-deep .payment {
  display: flex;
  align-items: center;
  flex-flow: column;
  justify-content: center;
}
::v-deep hr {
  background: none;
  box-shadow: none;
  height: 0;
  border: none;
  border-bottom: 1px solid #efefef;
}
::v-deep label.control-label {
  flex: 1;
  max-width: 100%;
  padding-top: 3px;
  padding-bottom: 3px;
  display: block;
  font-size: 14px;
  color: #222;
  font-weight: 400;
  text-transform: none;
  text-align: left;
  font-family: inherit;
  letter-spacing: 0px;
}

::v-deep h1 {
  padding-bottom: 0px;
  &:after {
    content: none;
    margin: 0px;
    padding: 0px;
  }
}



.payment-info ::v-deep .styled-radio-container--ou-donation.styled-radio-container {
  justify-content: center;
  .radio-part {
    min-width: 200px;
  }
  label {
    border: 2px solid #ddd;
    background: white;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 2px;
    font-weight: normal;
  }
  input[type='radio']:checked + label {
    background: radial-gradient(
        ellipse at center,
        #f9f6e9 0%,
        white 5%,
        #f1e8c7 100%
      ) !important;
    color: #141233;
  }
  label:hover {
    background: #f7f9fb;
  }
}

::v-deep .error-label {
  text-align: center;
}
.amex__notificion{
  font-style: italic;
    margin-bottom: 19px;
    font-size: 15px;
    margin-top: -7px;
}

.checktext {
  margin-top: -20px;
  line-height: 21px;
  p {
    margin-top: 5px;
  }
}
.designation-form-row.form-group {text-transform: uppercase;font-weight: 400;letter-spacing: 2px;font-size: 13px;color: #333;margin-bottom: 10px;}

.designation-form-row.form-group input[type=checkbox] {
    width: 20px;
    height: 20px;
    margin-right: 3px;
    border-radius: 4px;
    border: 2px solid #e8e2e1;
    background: #fff;
}

span.pre-dinner__text {
    display: block;
    line-height: normal;
    text-align: left;
}

.pre-dinner__label {
    display: flex;
    gap: 6px;
    align-items: center;
}
.designation-form-row.form-group {
    flex-flow: wrap;
}
.designation-form-row.form-group .full-width.form-group {
    min-width: 100%;
    max-width: 100%;
    padding-top: 10px;
}


::v-deep .label__consent {
  text-align: left;
  text-transform: none;
}
</style>
